/** Shared consultation status / payment badge helpers. */

/** MDI icon for consultation status badges (matches filter pill icons). */
const CONSULT_STATUS_ICONS = {
  draft: "mdi-file-document-outline",
  new: "mdi-star-four-points-outline",
  open: "mdi-star-four-points-outline",
  under_review: "mdi-progress-clock",
  under_study: "mdi-progress-clock",
  accepted: "mdi-check-circle-outline",
  finished: "mdi-flag-checkered",
  answered: "mdi-flag-checkered",
  closed: "mdi-flag-checkered",
  rejected: "mdi-close-circle-outline",
};

const CONSULT_STATUS_ID_TO_KEY = {
  1: "draft",
  2: "new",
  3: "under_review",
  4: "accepted",
  5: "finished",
};

export function consultStatusIconByCode(code) {
  const key = String(code || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_")
    .replace(/-+/g, "_");
  return CONSULT_STATUS_ICONS[key] || "mdi-label-outline";
}

export function consultStatusIconClass(statusId) {
  const key = CONSULT_STATUS_ID_TO_KEY[Number(statusId)];
  return key ? CONSULT_STATUS_ICONS[key] : "mdi-label-outline";
}

/** MDI icon for payment status badges. */
export function paymentStatusIconClass(value) {
  const s = String(value || "").toLowerCase();

  if (["under_review", "underreview", "review"].includes(s)) {
    return "mdi-clock-outline";
  }
  if (s === "paid") return "mdi-credit-card-check-outline";
  if (s === "unpaid") return "mdi-credit-card-off-outline";
  if (s === "rejected") return "mdi-close-circle-outline";
  if (s === "cancelled") return "mdi-cancel";
  if (s === "failed") return "mdi-alert-circle-outline";

  return "mdi-help-circle-outline";
}
